import React, { Component } from 'react';
import { connect } from 'react-redux';
import { _LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import { recommendEventActions } from '../../../store/modules/recommend/event';
import {
  RECOMMEND_EVENT_LIST_SEARCH_DATA_MODEL,
  RECOMMEND_EVENT_LIST_SEARCH_OPTION_MODEL,
} from '../../../store/modules/recommend/event/models';
import RecommendEventListWrap from '../../../views/recommend/event/list/RecommendEventListWrap';

class RecommendEventListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    const { setData } = this.props;

    this.getList({
      /**
       *  검색 옵션
       */
      searchOption: RECOMMEND_EVENT_LIST_SEARCH_OPTION_MODEL,
      /**
       *  pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    });

    /**
     * 검색 박스 초기화
     */
    setData({
      path: ['recommendEventList', 'searchData'],
      value: RECOMMEND_EVENT_LIST_SEARCH_DATA_MODEL,
    });
  };

  /**
   * 리스트 불러오기
   */
  getList = (data) => {
    const { getRecommendEventList, recommendEventList } = this.props;
    const { searchOption, sortOption, pagination } = recommendEventList;

    getRecommendEventList({
      searchOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  render() {
    const { recommendEventList, setData } = this.props;

    return <RecommendEventListWrap recommendEventList={recommendEventList} setData={setData} getList={this.getList} />;
  }
}

const mapStateToProps = (state) => {
  return {
    recommendEventList: state.recommendEvent.recommendEventList,
  };
};

const mapDispatchToProps = {
  setData: recommendEventActions.setData,
  getRecommendEventList: recommendEventActions.getRecommendEventList,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecommendEventListContainer);
